import { FC, useRef } from 'react';

import { Helmet } from 'react-helmet';

import useAuth from 'hooks/useAuth';

const ZE_SCRIPT_TAG_ID = 'ze-snippet';

const ZendeskChat: FC = () => {
  const isLoadListenerAdded = useRef<boolean>(false);
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Helmet
      onChangeClientState={(newState, ...a) => {
        const scriptTag = document.getElementById(ZE_SCRIPT_TAG_ID);

        if (user && scriptTag && !isLoadListenerAdded.current) {
          isLoadListenerAdded.current = true;

          scriptTag.addEventListener('load', () => {
            window.zE?.(function () {
              window.zE?.identify?.({
                name: `${user.profile?.first_name ? `${user.profile.first_name} ` : ''}${
                  user.profile?.last_name || ''
                }`,
                email: user.email,
              });
            });
          });
        }
      }}
    >
      <script
        id={ZE_SCRIPT_TAG_ID}
        src="https://static.zdassets.com/ekr/snippet.js?key=c8d7cbec-df1c-4deb-b93e-575a948fba14"
      />
    </Helmet>
  );
};

export default ZendeskChat;
